import { render, staticRenderFns } from "./companyView.vue?vue&type=template&id=d629493c&"
import script from "./companyView.vue?vue&type=script&lang=js&"
export * from "./companyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports